import { environment } from '@lla-platform/core/core-util'

export const ADDONS_API_URL = {
  addonsSummary: `${environment.apiUrl}/addons/summary`,
  exportAddonsSummary: `${environment.apiUrl}/addons/summary/export`
}
